import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const PatientCommunicationTypePage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'type', label: 'Communication Type' },
    { key: 'description', label: 'Description' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'type', label: 'Communication Type', type: 'text', required: true },
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'PHONE', type: 'Phone Call', description: 'Phone call to/from patient', active: 'Yes' },
    { id: '2', code: 'VISIT', type: 'Home Visit', description: 'Face-to-face visit at patient home', active: 'Yes' },
    { id: '3', code: 'EMAIL', type: 'Email', description: 'Email communication', active: 'Yes' },
    { id: '4', code: 'TELE', type: 'Telehealth', description: 'Video call/telehealth visit', active: 'Yes' },
    { id: '5', code: 'MAIL', type: 'Mail', description: 'Written correspondence via mail', active: 'Yes' },
    { id: '6', code: 'PORTAL', type: 'Patient Portal', description: 'Message via patient portal', active: 'Yes' },
    { id: '7', code: 'CAREGVR', type: 'Caregiver Contact', description: 'Communication with family/caregiver', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Patient Communication Type"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Type"
      formFields={formFields}
      apiEndpoint="/setup/patient-communication-type"
    />
  );
};

export default PatientCommunicationTypePage;
